module.exports = __webpack_public_path__ + "img/sort-asc.14ffe5cc.svg";